/**
 * ── AUTO-DETECT A TYPED HOMESITE'S REAL LINK (2026-08-21) ─────────────────────
 * Jack, on the per-card/button mockups: "no, this kind of thing should just be
 * in there… wasn't sure if you could auto detect or something." So it is not a
 * control — it is behaviour: when a MANUAL home's typed homesite exactly matches
 * the community's live inventory (the same /sfmc-content feed Dynamic fills
 * from) and its View URL is still blank, the home's own URL is written in, with
 * a toast saying so. Anything unmatched keeps the red flag and the Done gate.
 *
 * THE MATCH IS EXACT OR NOTHING. A typed value matches a homesite on its short
 * lot (what the Dynamic fill itself displays), its raw lot, or its address —
 * case-insensitive, whitespace-collapsed, whole-value. If zero or MORE THAN ONE
 * homesite matches, the answer is "": a near-miss or an ambiguous number must
 * never pick a link. Sold homes are excluded, same rule as the picker.
 */
import type { Pack } from "./dynamicFill";
import { notSold } from "./dynamicFill";
import { echShortLot } from "./echDyn";

const norm = (s: unknown) => String(s ?? "").trim().replace(/\s+/g, " ").toLowerCase();
const REAL = /^https?:\/\/[^\s/]+\./i;

export function homeUrlLookup(packs: readonly Pack[] | null | undefined, typed: unknown): string {
  const want = norm(typed);
  if (!want) return "";
  const hits = new Set<string>();
  for (const p of packs || []) {
    for (const h of (p.C && p.C.homesites) || []) {
      if (!notSold(h)) continue;
      const url = String(h.url || "");
      if (!REAL.test(url)) continue;
      const lot = (h as { lot?: unknown }).lot;
      const keys = [echShortLot(lot, p.code), String(lot ?? ""), String(h.addr ?? "")];
      if (keys.some((k) => norm(k) && norm(k) === want)) hits.add(url);
      if (hits.size > 1) return "";                       /* ambiguous — never guess */
    }
  }
  return hits.size === 1 ? Array.from(hits)[0] : "";
}
